import { useState, useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Helpers } from 'pda-components'
import dayjs from 'dayjs'
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)

// ตรวจสอบว่าค่าที่ได้เป็น Unix timestamp จริงหรือไม่
const isValidTimestamp = (value) => {
  return Number.isInteger(value) && value > 0
}

const useCloseWeb = () => {
  const { getCookie, setCookie, removeCookie, getEnv } = Helpers
  const [searchParams] = useSearchParams()
  const [configData, setConfigData] = useState(null)
  const [configLoading, setConfigLoading] = useState(true)

  // อ่าน system-config closeweb ตั้งแต่เริ่มต้นและเก็บไว้ใน state
  useEffect(() => {
    const config = {
      closeweb_status: parseInt(getEnv('closeweb_status')) || 0,
      closeweb_startdate: getEnv('closeweb_startdate') || '',
      closeweb_enddate: getEnv('closeweb_enddate') || '',
      closeweb_text: getEnv('closeweb_text') || ''
    }
    setConfigData(config)
    setConfigLoading(false)
  }, [])

  const openWeb = useMemo(() => {
    // ถ้ายังไม่มี config ให้เปิดเว็บไปก่อน
    if (!configData) return 1

    // กำหนดช่วงเวลาปิดเว็บ
    const startTime = dayjs(configData?.closeweb_startdate)
    const endTime = dayjs(configData?.closeweb_enddate)
    const closewebDateBetween = dayjs().isBetween(startTime, endTime)
    const closeweb = configData?.closeweb_status === 1 && closewebDateBetween ? 1 : 0

    // จัดการ forceOpen จาก query string
    const forceQueryString = searchParams.get('force')
    if (window.location.pathname === '/login') {
      removeCookie('forceOpen')
    }
    if (forceQueryString) {
      setCookie('forceOpen', forceQueryString, 8 * 60 * 60) // 8 ชั่วโมง
    }

    if (closeweb === 1) {
      const forceOpenCookie = parseInt(getCookie('forceOpen'))
      if (forceOpenCookie && forceOpenCookie === 1) {
        // dev mode: force=1
        return 1
      } else if (forceOpenCookie && forceOpenCookie !== 1) {
        // ลูกค้าส่ง timestamp มา ตรวจสอบว่ายังไม่เกิน closeweb_enddate
        const timestampConfigDB = dayjs(configData?.closeweb_enddate).valueOf()
        if (isValidTimestamp(forceOpenCookie) && forceOpenCookie <= timestampConfigDB) {
          return 1
        }
        return 0
      }
      return 0
    }

    return 1
  }, [configData, searchParams])

  return { openWeb, configData, configLoading }
}

export default useCloseWeb
